(() => {
  const SELECTORS = [
    // Best Sellers (featured collection)
    ".template-index .mekipow-best-sellers .m-mixed-layout__wrapper",
    // About MekiPow Tools (custom-content videos)
    ".template-index .mekipow-home-videos .m-custom-content__wrapper",
  ];

  const prefersReducedMotion = () =>
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const isMobile = () =>
    window.matchMedia && window.matchMedia("(max-width: 767px)").matches;

  function setupMarquee(wrapper) {
    if (!wrapper || wrapper.dataset.mekipowMarqueeInit === "1") return;
    wrapper.dataset.mekipowMarqueeInit = "1";

    // Enable section-scoped CSS tweaks (disable snap, etc).
    wrapper.classList.add("mekipow-marquee--on");

    let rafId = 0;
    let lastTs = 0;
    let direction = 1;
    let paused = false;
    let resumeTimer = null;

    // 桌面端速度略慢，移动端稍快
    const speedPxPerSec = isMobile() ? 22 : 16;

    const getMaxScroll = () => Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);

    const pause = () => {
      paused = true;
      if (resumeTimer) window.clearTimeout(resumeTimer);
    };

    const resumeSoon = () => {
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        paused = false;
      }, 1200);
    };

    const tick = (ts) => {
      rafId = window.requestAnimationFrame(tick);
      if (paused) {
        lastTs = ts;
        return;
      }

      const maxScroll = getMaxScroll();
      if (maxScroll <= 0) return;

      const dt = lastTs ? (ts - lastTs) / 1000 : 0;
      lastTs = ts;

      const next = wrapper.scrollLeft + direction * speedPxPerSec * dt;
      if (next <= 0) {
        wrapper.scrollLeft = 0;
        direction = 1;
      } else if (next >= maxScroll) {
        wrapper.scrollLeft = maxScroll;
        direction = -1;
      } else {
        wrapper.scrollLeft = next;
      }
    };

    // Pause while user interacts / scrolls manually.
    wrapper.addEventListener("touchstart", pause, { passive: true });
    wrapper.addEventListener("touchend", resumeSoon, { passive: true });
    wrapper.addEventListener("pointerdown", pause, { passive: true });
    wrapper.addEventListener("pointerup", resumeSoon, { passive: true });
    wrapper.addEventListener("wheel", () => {
      pause();
      resumeSoon();
    }, { passive: true });
    wrapper.addEventListener("scroll", () => {
      // if user scrolls, don't fight it
      pause();
      resumeSoon();
    }, { passive: true });

    // Pause when offscreen.
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          const visible = entries.some((e) => e.isIntersecting);
          paused = !visible;
        },
        { threshold: 0.15 }
      );
      io.observe(wrapper);
    }

    // Recompute on resize.
    window.addEventListener(
      "resize",
      () => {
        lastTs = 0;
      },
      { passive: true }
    );

    rafId = window.requestAnimationFrame(tick);
  }

  function boot() {
    if (prefersReducedMotion()) return;

    SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach((wrapper) => setupMarquee(wrapper));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

